import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'
import { ref } from 'vue'
const isSafariFun=()=> {
  const userAgent = window.navigator.userAgent;

  // 判断是否是 Safari
  const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);

  // 判断是否是 iOS 的 Safari
  // const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

  return isSafari
}
export function useBasicLayout() {
  const userAgent = navigator.userAgent.toLowerCase();
  const breakpoints = useBreakpoints({
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xx: 1440,
    xxl: 1600,
    xx1540:1540,
  })
  const isMobile = breakpoints.smaller('sm')
  const isMobileNew = breakpoints.smaller('sm')//因为vant里暴露的这个方法重复了
  // const isMobile = ref(false)
  const isH5 = ref(true)
  const isxl = breakpoints.smaller('xl')
  const ismd = breakpoints.smaller('md')
  const islg= breakpoints.smaller('lg')
  const isxx = breakpoints.smaller('xx')
  const isxx1540=breakpoints.smaller('xx1540')
  const isSafari=userAgent.includes('safari') && !userAgent.includes('chrome')
  const isSafariNew=isSafariFun()
 
  // if (isMobile1.value && navigator.userAgent.match(/('phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone')/i)) {
  //   isMobile.value = true
  // } else {
  //   isMobile.value = false
  // }
  return { isMobile,isxl,ismd,isH5,isSafari,isSafariNew,isMobileNew,islg,isxx,isxx1540,isSafariNew}
}


